<template>
  <div class="sector-card">
    <h3 class="sector-card-title">{{title}}</h3>
    <div class="sector-list">
      <div v-for="(sector, index) in five_sectors" :key="index" class="sector-item">
        <div class="sector-header" @click="toggleVisibility(index)">
          <div class="sector-info">
            <div class="sector-title-row">
              <span class="sector-rank">{{ index + 1 }}.</span>
              <span class="sector-name">{{ getTranslatedSectorName(sector.name) }}</span>
            </div>
            <div class="sector-profit-row">
              <span class="sector-profit" :class="getProfitClass(sector.profit)">Rendimiento: {{ formatProfit(sector.profit) }}</span>
            </div>
          </div>
          <span class="material-icons toggle-icon" :class="{ 'rotated': sectorVisibility[index] }">
            keyboard_arrow_down
          </span>
        </div>
        <transition name="expand">
          <div v-show="sectorVisibility[index]" class="sector-details">
            <div class="details-content">
              <p class="eurekers-value">
                Valores Eurekers: 
                <span class="value-highlight">{{ getSectorEurekersValue(sector.name) }}</span>
              </p>
              <div class="chart-container">
                <highcharts :options="_optionsChart(index)"></highcharts>
              </div>
              <button @click.prevent="_userPermissionShowStockchart(sector.name)" class="action-button">
                VER EN GD
              </button>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Sector',
  props: {
    sector_timing: String,
    title: String,
    five_sectors: Array,
    eurekers_values: Object,
  },
  data: () => ({
    sectorVisibility: {},
    HC : {
      0: { options: { chart: {type: 'line', zoomType: 'x', backgroundColor: 'transparent' }, title: {text: ''}, xAxis: {type: 'datetime'}, yAxis: { title: { text: null } }, series: [{data: [[]], color: 'var(--color-highlight)', name:''}], credits: { enabled: false }, legend: { enabled: false } } },
      1: { options: { chart: {type: 'line', zoomType: 'x', backgroundColor: 'transparent' }, title: {text: ''}, xAxis: {type: 'datetime'}, yAxis: { title: { text: null } }, series: [{data: [[]], color: 'var(--color-highlight)', name:''}], credits: { enabled: false }, legend: { enabled: false } } },
      2: { options: { chart: {type: 'line', zoomType: 'x', backgroundColor: 'transparent' }, title: {text: ''}, xAxis: {type: 'datetime'}, yAxis: { title: { text: null } }, series: [{data: [[]], color: 'var(--color-highlight)', name:''}], credits: { enabled: false }, legend: { enabled: false } } },
      3: { options: { chart: {type: 'line', zoomType: 'x', backgroundColor: 'transparent' }, title: {text: ''}, xAxis: {type: 'datetime'}, yAxis: { title: { text: null } }, series: [{data: [[]], color: 'var(--color-highlight)', name:''}], credits: { enabled: false }, legend: { enabled: false } } },
      4: { options: { chart: {type: 'line', zoomType: 'x', backgroundColor: 'transparent' }, title: {text: ''}, xAxis: {type: 'datetime'}, yAxis: { title: { text: null } }, series: [{data: [[]], color: 'var(--color-highlight)', name:''}], credits: { enabled: false }, legend: { enabled: false } } },
    },
    // Sector name translations
    sectorTranslations: {
      // Main sectors
      "Utilities": "Servicios Públicos",
      "Consumer Staples": "Productos Básicos de Consumo",
      "Financials": "Finanzas",
      "Materials": "Materiales",
      "Health Care": "Salud",
      "Industrials": "Industriales",
      "Real Estate": "Bienes Raíces",
      "Energy": "Energía",
      "Communication Services": "Servicios de Comunicación",
      "Consumer Discretionary": "Consumo Discrecional",
      "Information Technology": "Tecnología de la Información",
      
      // Sub-sectors
      "Consumer Staples Distribution & Retail": "Distribución y Venta de Productos Básicos",
      "Household & Personal Products": "Productos de Hogar y Personales",
      "Food, Beverage & Tobacco": "Alimentos, Bebidas y Tabaco",
      "Banks": "Bancos",
      "Diversified Financials": "Finanzas Diversificadas",
      "Insurance": "Seguros",
      "Financial Services": "Servicios Financieros",
      "Materials": "Materiales",
      "Pharmaceuticals, Biotechnology & Life Sciences": "Farmacéuticas, Biotecnología y Ciencias de la Vida",
      "Health Care Equipment & Services": "Equipos y Servicios de Salud",
      "Commercial & Professional Services": "Servicios Comerciales y Profesionales",
      "Transportation": "Transporte",
      "Capital Goods": "Bienes de Capital",
      "Equity Real Estate Investment Trusts (REITs)": "Fideicomisos de Inversión en Bienes Raíces (REITs)",
      "Real Estate": "Bienes Raíces",
      "Energy": "Energía",
      "Media & Entertainment": "Medios y Entretenimiento",
      "Telecommunication Services": "Servicios de Telecomunicaciones",
      "Consumer Durables & Apparel": "Bienes de Consumo Duraderos y Ropa",
      "Consumer Services": "Servicios al Consumidor",
      "Consumer Discretionary Distribution & Retail": "Distribución y Venta de Consumo Discrecional",
      "Semiconductors & Semiconductor Equipment": "Semiconductores y Equipos Semiconductores",
      "Technology Hardware & Equipment": "Hardware y Equipos Tecnológicos",
      "Software & Services": "Software y Servicios",
      "Utilities": "Servicios Públicos"
    }
  }),
  mounted() {
    // Initial data load
    this.loadSectorData();
    
    // Set up interval to refresh data every 10 seconds
    this.dataRefreshInterval = setInterval(() => {
      this.loadSectorData();
    }, 2500);
  },
  
  beforeDestroy() {
    // Clear the interval when component is destroyed
    if (this.dataRefreshInterval) {
      clearInterval(this.dataRefreshInterval);
    }
  },
  methods: {
    loadSectorData() {
      // Check if five_sectors is an array before iterating
      if (Array.isArray(this.five_sectors)) {
        this.five_sectors.forEach((element, index) => {
          this._fillChartDataSector(element, index);
          // Initialize visibility state if not already set
          if (this.sectorVisibility[index] === undefined) {
            this.$set(this.sectorVisibility, index, false);
          }
        });
      }
  },
    toggleVisibility(index) {
      this.$set(this.sectorVisibility, index, !this.sectorVisibility[index]);
    },
    
    _userPermissionShowStockchart(sector) {
      this.$router.push('/app/graficador-dinamico/sector/' + sector);
    },

    _fillChartDataSector(element, index) {
      let daysAgo = 31; // Default to 1 month
      switch (this.sector_timing) {
        case '3m': daysAgo = 93; break;
        case '1y': daysAgo = 365; break;
      }

      this.HC[index].options.xAxis.min = this._formatDateToCalculateDaysRangeToSetZoomSectorChart(daysAgo);
      this.HC[index].options.xAxis.max = this._formatDateToCalculateDaysRangeToSetZoomSectorChart(0);
      this.HC[index].options.series[0].data = element.chart_data_series;
      this.HC[index].options.series[0].name = this.getTranslatedSectorName(element.name);
    },

    _optionsChart(index) {
      return this.HC[index].options;
    },

    _formatDateToCalculateDaysRangeToSetZoomSectorChart: function(days_ago) {
      const calculate_date = new Date();
      calculate_date.setDate(calculate_date.getDate() - days_ago);
      return Date.UTC(calculate_date.getUTCFullYear(), calculate_date.getUTCMonth(), calculate_date.getUTCDate());
    },

    getProfitClass(profit) {
      // Remove percentage symbol and convert to number
      const numValue = parseFloat(String(profit).replace('%', '').trim());
      
      if (numValue > 0) {
        return 'positive-profit';
      } else if (numValue < 0) {
        return 'negative-profit';
      } else {
        return '';
      }
    },
    
    getTranslatedSectorName(name) {
      return this.sectorTranslations[name] || name;
    },
    
    getSectorEurekersValue(sectorName) {
      // First check if we have this sector directly in eurekers_values
      if (this.eurekers_values && this.eurekers_values[sectorName]) {
        return this.eurekers_values[sectorName];
      }
      
      // If not found directly, try with the translated name (in case the eurekers_values use translated keys)
      const translatedName = this.getTranslatedSectorName(sectorName);
      if (translatedName !== sectorName && this.eurekers_values && this.eurekers_values[translatedName]) {
        return this.eurekers_values[translatedName];
      }
      
      // If still not found, return a fallback
      return "N/A";
    },
    formatProfit(profit) {
      if (!profit) return "N/A";
      // Remove percentage symbol and convert to number
      const numValue = parseFloat(String(profit).replace('%', '').trim());
      return isNaN(numValue) ? "N/A" : numValue.toFixed(2) + '%';
    }
  },
}
</script>

<style lang="scss" scoped>
.sector-card {
  background-color: var(--color-surface);
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid var(--color-outline);
  overflow: hidden;
  flex: 1 1 300px; // Allow cards to grow and shrink, with a base width
  margin-bottom: 24px; // Add margin between cards if they wrap
  min-width: 300px; // Minimum width before wrapping
}

.sector-card-title {
  padding: 16px 20px;
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--color-text-primary);
  background-color: var(--color-background);
  border-bottom: 1px solid var(--color-outline);
}

.sector-list {
  padding: 0;
  margin: 0;
}

.sector-item {
  border-bottom: 1px solid var(--color-outline);
  &:last-child {
    border-bottom: none;
  }
}

.sector-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 16px 20px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: var(--color-active-surface);
  }
}

.sector-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.sector-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.sector-rank {
  font-weight: bold;
  color: var(--color-text-secondary);
  min-width: 20px; // Ensure rank number alignment
}

.sector-name {
  font-weight: 600;
  color: var(--color-text-primary);
}

.sector-profit-row {
  display: flex;
  align-items: center;
  padding-left: 30px; // Indent to align with sector name
}

.sector-profit {
  font-size: 12px;
  color: var(--color-text-secondary);
  background-color: var(--color-background);
  padding: 2px 6px;
  border-radius: 4px;
  
  &.positive-profit {
    color: var(--color-success, #28a745);
    background-color: rgba(40, 167, 69, 0.1);
  }
  
  &.negative-profit {
    color: var(--color-error, #dc3545);
    background-color: rgba(220, 53, 69, 0.1);
  }
}

.toggle-icon {
  color: var(--color-text-secondary);
  transition: transform 0.3s ease;
}

.toggle-icon.rotated {
  transform: rotate(180deg);
}

.sector-details {
  overflow: hidden;
}

.details-content {
  padding: 16px 20px;
  background-color: var(--color-background);
  border-top: 1px solid var(--color-outline);
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.eurekers-value {
  font-size: 14px;
  color: var(--color-text-primary);
  margin: 0;
}

.value-highlight {
  font-weight: bold;
  color: var(--color-primary);
}

.chart-container {
  // height: 250px; // Removed fixed height
  border: 1px solid var(--color-outline);
  border-radius: 4px;
  background-color: var(--color-surface); // Slightly different background for chart
  overflow: hidden;
}

.action-button {
  background-color: var(--color-highlight); // Changed from --color-primary
  color: var(--color-text-on-highlight, white);
  border: none;
  border-radius: 20px;
  padding: 8px 24px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1px;
  cursor: pointer;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
  text-transform: uppercase;
  align-self: center;

  &:hover {
    filter: brightness(0.9); // Keep using filter for hover
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  }
}

// Transition for expanding/collapsing details
.expand-enter-active,
.expand-leave-active {
  transition: height 0.3s ease, opacity 0.3s ease;
  overflow: hidden;
}

.expand-enter, .expand-leave-to /* .expand-leave-active below version 2.1.8 */ {
  height: 0;
  opacity: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0;
  margin-bottom: 0;
}

/* Deep selector for Highcharts styling */
:deep(.highcharts-background) {
  fill: var(--color-background);
}

:deep(.highcharts-axis-labels text), 
:deep(.highcharts-yaxis-labels text) {
  fill: var(--color-text-secondary) !important;
}

:deep(.highcharts-tooltip) {
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0.9);
  border: 1px solid var(--color-outline);
  box-shadow: var(--shadow-light);
}

:deep(.highcharts-tooltip text) {
  fill: var(--color-text-primary) !important;
}
</style>